export default __webpack_public_path__ + "static/media/KC_animated_logo.e5c7ddca.gif";